export {
    embedCreateRequestRoute,
    embedSinglePortalRoute,
    embedKBArticleRoute,
    embedFeaturedPortalsRoute,
    getEmbedCreateRequestRoute,
} from './routes';
